import { TreeListItemTsoPqProps } from '@custom-types/TreeTypes';

export const useFlattenTreeProp = (options: TreeListItemTsoPqProps[], prop: string): string[] => {
  return (
    options?.flatMap((node: TreeListItemTsoPqProps) => [
      node[prop as keyof typeof node] as string,
      ...(node.options ? useFlattenTreeProp(node.options, prop) : []),
    ]) ?? []
  );
};

export const useFlattenTreeProps = (options: TreeListItemTsoPqProps[], props: string[]): object[] => {
  return (
    options?.flatMap((node: TreeListItemTsoPqProps) => [
      props.reduce(
        (acc, prop) => {
          acc[prop] = node[prop as keyof typeof node];
          return acc;
        },
        {} as Record<string, any>
      ),
      ...(node.options ? useFlattenTreeProps(node.options, props) : []),
    ]) ?? []
  );
};
